// Key mapping fallback based on https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values
const keyMapping = {
  Escape: {
    key: ['Escape', 'Esc'],
    keyCode: 27,
  },
  ArrowLeft: {
    key: ['ArrowLeft', 'Left'],
    keyCode: 37,
  },
  ArrowRight: {
    key: ['ArrowRight', 'Right'],
    keyCode: 39,
  },
  ArrowUp: {
    key: ['ArrowUp', 'Up'],
    keyCode: 38,
  },
  ArrowDown: {
    key: ['ArrowDown', 'Down'],
    keyCode: 40,
  },
  Delete: {
    key: ['Delete', 'Del'],
    keyCode: 46,
  },
};

export default function keymatch(event, keyItems) {
  let keys = keyItems;

  if (!Array.isArray(keys)) {
    keys = [keys];
  }

  return keys.some((key) => {
    const mapping = keyMapping[key];

    // if tested key does not match keyMapping fallbacks
    // match it directly to the key property
    if (!mapping) {
      return event.key === key;
    }

    return (
      mapping.key.indexOf(event.key) > -1 || mapping.keyCode === event.keyCode
    );
  });
}
